"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeParser = void 0;
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
class TypeParser extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    defaultResult() {
        return {
            type: 'PrimitiveType',
            signed: undefined,
            valueType: 'void'
        };
    }
    visitType(ctx) {
        return {
            type: 'PrimitiveType',
            signed: undefined,
            valueType: ctx.text
        };
    }
}
exports.TypeParser = TypeParser;
//# sourceMappingURL=typeParser.js.map